<template>
  <div
    class="chat-incident-created chat-bubble"
    v-bind:class="{
      'from-customer': message.DIRECTION === 'customer2club',
      'from-club': message.DIRECTION === 'club2customer',
    }"
  >
    <MessageDate :timestamp="message.TIMESTAMP"> </MessageDate>
    <p class="first-headline oeamtc-headline">
      <strong>Nothilfe angefordert</strong>
    </p>
    <p>
      <span class="headline">Telefonnummer</span>
      {{ message.submitted_request.contact.CALLBACKNUMBER }}
    </p>
    <p>
      <span class="headline">Fahrzeug</span>
      {{ message.submitted_request.vehicle.BRAND }} -
      {{ message.submitted_request.vehicle.TYPE }} <br />
      {{ message.submitted_request.vehicle.NUMBERPLATE }}
    </p>
    <p>
      <span class="headline">Ursache</span>
      {{ message.submitted_request.fault.FAULT_NAME }}
      <template
        v-if="
          message.submitted_request.fault.FAULT_TEXT &&
          message.submitted_request.fault.FAULT_TEXT !== ''
        "
      >
        <br />{{ message.submitted_request.fault.FAULT_TEXT }}
      </template>
    </p>
    <p>
      <MglMap
        class="map"
        :accessToken="accessToken"
        :dragPan="false"
        :scrollZoom="false"
        :mapStyle="mapStyle"
        :center="[message.location.lon, message.location.lat]"
        :zoom="15"
      >
        <MglMarker
          :coordinates="[message.location.lon, message.location.lat]"
          color="#404040"
        />
      </MglMap>
    </p>
  </div>
</template>

<script>
import MessageDate from '../MessageDate.vue';
import Mapbox from 'mapbox-gl';
import { MglMap, MglMarker } from 'vue-mapbox';

export default {
  name: 'IncidentCreated',
  props: ['message'],
  components: {
    MessageDate,
    MglMap,
    MglMarker,
  },
  data() {
    return {
      accessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
      mapStyle: process.env.VUE_APP_MAPBOX_STYLE,
    };
  },
  created() {
    this.mapbox = Mapbox;
  },
};
</script>

<style lang="scss" scoped>
.map {
  height: 300px;
  border-radius: $default-radius;
  overflow: hidden;
}
.oeamtc-headline {
  margin-bottom: 1rem;
}

.headline {
  margin: 0.5rem 0 0;
  font-weight: 500;
  display: block;
}
</style>
